import SignUpPage from './SignUpPage';
import authRoles from '../../auth/authRoles';
import PrivacyPolicy from '../privacy-policy';
import TermsOfService from '../terms';


const SignUpConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: 'sign-up',
      element: <SignUpPage />,
    },
    {
      path: "privacy-policy",
      element: <PrivacyPolicy />
    },
    {
      path: "terms",
      element: <TermsOfService />
    },
  ],
};

export default SignUpConfig;
